module.exports = __webpack_public_path__ + "img/account.beaf4920.svg";